import { useMemo, useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { AggregateDefinition } from '@terragotech/gen5-shared-components';
import { visibleRecordTypeKeysState } from '../../recoil/atoms';

export interface UseVisibleAggregatesStateArgs {
  aggregateDefinitions: AggregateDefinition[];
}

export interface UseVisibleAggregatesStateReturnType {
  visibleAggregateTypesKeys: string[];
  visibleAggregateTypesNames: string[];
  setVisibleAggregateTypesNames: (names: string[]) => void;
}

export const useVisibleAggregatesState = ({
  aggregateDefinitions,
}: UseVisibleAggregatesStateArgs): UseVisibleAggregatesStateReturnType => {
  const [visibleAggregateTypesKeys, setVisibleAggregateTypesKeys] = useRecoilState(visibleRecordTypeKeysState);
  const visibleAggregateTypesNames = useMemo(
    () =>
      aggregateDefinitions
        .filter(definition => visibleAggregateTypesKeys.includes(definition.queryKey))
        .map(definition => definition.name),
    [aggregateDefinitions, visibleAggregateTypesKeys]
  );
  const setVisibleAggregateTypesNames = useCallback(
    (names: string[]) => {
      const newKeys = aggregateDefinitions
        .filter(definition => names.includes(definition.name))
        .map(definition => definition.queryKey);
      setVisibleAggregateTypesKeys(newKeys);
    },
    [aggregateDefinitions]
  );

  return {
    visibleAggregateTypesKeys,
    visibleAggregateTypesNames,
    setVisibleAggregateTypesNames,
  };
};
